const signinRedirectAttemptsKey = "vesl.signinRedirectAttempts";
const signinRedirectAttemptWindowMs = 60 * 1000;
const signinRedirectAttemptLimit = 3;

export class SigninRedirectGuard {
	constructor(storage, logger, options = {}) {
		this.storage = storage;
		this.logger = logger;
		this.memoryAttempts = [];
		this.storageKey = options.storageKey || signinRedirectAttemptsKey;
		this.attemptWindowMs = options.attemptWindowMs || signinRedirectAttemptWindowMs;
		this.attemptLimit = options.attemptLimit || signinRedirectAttemptLimit;
		this.getNow = options.getNow || Date.now;
	}

	tryRecordAttempt = () => {
		const now = this.getNow();
		const attempts = this.getAttempts()
			.filter(attempt => now - attempt < this.attemptWindowMs);

		if(attempts.length >= this.attemptLimit) {
			this.setAttempts(attempts);
			return false;
		}

		attempts.push(now);
		this.setAttempts(attempts);

		return true;
	}

	clear = () => {
		this.memoryAttempts = [];

		try {
			this.storage?.removeItem(this.storageKey);
		}
		catch(error) {
			this.logger.exception(error, "Failed to clear authentication redirect attempts");
		}
	}

	getAttempts = () => {
		try {
			const attempts = JSON.parse(this.storage?.getItem(this.storageKey)) || [];

			if(!Array.isArray(attempts)) {
				return [];
			}

			return attempts.filter(attempt => typeof attempt === "number" && isFinite(attempt));
		}
		catch(error) {
			this.logger.exception(error, "Failed to parse authentication redirect attempts");

			return this.memoryAttempts;
		}
	}

	setAttempts = (attempts) => {
		this.memoryAttempts = attempts;

		try {
			this.storage?.setItem(this.storageKey, JSON.stringify(attempts));
		}
		catch(error) {
			this.logger.exception(error, "Failed to persist authentication redirect attempts");
		}
	}
}
